import { Plus } from 'lucide-react';
import { motion } from 'framer-motion';
import { IconButton } from './IconButton';

interface AnnotationButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

export function AnnotationButton({ onClick, isOpen }: AnnotationButtonProps) {
  return (
    <IconButton 
      onClick={onClick} 
      title={isOpen ? 'Close Annotation (Esc)' : 'Add Annotation (A)'}
      className="tw-w-10 tw-h-10 tw-bg-white/10 tw-hover:tw-bg-white/20 tw-transition-colors tw-duration-200"
    >
      <motion.div
        initial={false}
        animate={{ rotate: isOpen ? 45 : 0 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <Plus className="tw-h-5 tw-w-5" />
      </motion.div>
    </IconButton>
  );
}